import React from 'react';
import './styles/Footer.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faTiktok, faXTwitter, faFacebookF } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
    return (
        <footer className="footer min-w-460">
            <p>
                Contacto: <a href="mailto:contacto@mynookapp.es">contacto@mynookapp.es</a>
            </p>
            
            <div className="social-icons">
                <a href="https://www.instagram.com/mynookapp/" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faInstagram} />
                </a>

                <a href="https://www.tiktok.com/@mynookapp" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faTiktok} />
                </a>

                <a href="https://x.com/mynookapp_Ofcl" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faXTwitter} />
                </a>

                <a href="https://www.facebook.com/profile.php?id=61573438056002" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faFacebookF} />
                </a>
            </div>


            <p>
                Aviso: No nos hacemos responsables de los datos que se introduzcan en esta web.
                <br></br>
                <a href="/PrivacyPolicy.html">Política de Privacidad</a>
            </p>

            <div className="copyright">
                <p>&copy; {new Date().getFullYear()} MyNookapp. Todos los derechos reservados.</p>
            </div>            
        </footer>        
    );
};

export default Footer;